<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bn2dpn/tc-custom/9781514004623.jpg?1688600506308" alt="This image is the cover for the book Message of Deuteronomy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Message of Deuteronomy
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>No Old Testament book has exerted a greater influence on the formation of both Jewish and Christian thought and practice than Deuteronomy.</strong> It presents the final message of Moses to the people of Israel, providing foundational theology for the rest of Scripture. When we read Deuteronomy today, we hear Moses address us as a future generation of the covenant people of God. The challenges and needs faced by the Israelites still resonate with believers in every new era. Raymond Brown's<em>The Message of Deuteronomy</em> guides Christians to hear and appreciate the timeless relevance of this ancient message. Brown's compilation of historical and biblical background complements his even-handed, insightful commentary while maintaining a readable style. Uncover the choice between blessings and curses, life and death laid out in Deuteronomy. This revised edition of a classic Bible Speaks Today volume features lightly updated language, current NIV Scripture quotations, and a new interior design.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raymond Brown
      </h2>
      
      <p class="authorDescription body article"><p>Raymond Brown, formerly principal of Spurgeon's College in London, was a pastor for many years. He is the author of <em>Philosophy of Religion</em>, <em>Why Believe?</em>, and several volumes in IVP's Bible Speaks Today series.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6423094a